import { render, staticRenderFns } from "./TdcV2.vue?vue&type=template&id=41fb6e2b&scoped=true&"
import script from "./TdcV2.vue?vue&type=script&lang=js&"
export * from "./TdcV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fb6e2b",
  null
  
)

export default component.exports